import { combineReducers } from "@reduxjs/toolkit";
import displaySuperSpec from "./displaySuperSpecSlice";

const reducer = combineReducers({
  displaySuperSpec,
});

export default reducer;
